import { useReactiveVar } from '@apollo/client';
import { EuiFormLabel } from '@elastic/eui';
import { engineDisplacementInCM3 } from 'cache';
import { RangeFilter } from 'components/RangeFilter/RangeFilter';
import { WHITE_LABELS } from 'CONST';
import { carEngineDisplacementInCM3Options, motoEngineDisplacementInCM3Options } from 'enums/G';
import { useIntl } from 'react-intl';
import { getOptions } from 'utils';

import * as S from './FiltersSidebar.styles';

export const EngineDisplacementInCM3Filter = (): JSX.Element => {
  const { formatMessage } = useIntl();
  const options = useReactiveVar(engineDisplacementInCM3);

  const getEngineDisplaceMentByDomain = ():
    | typeof motoEngineDisplacementInCM3Options
    | typeof carEngineDisplacementInCM3Options => {
    const whiteLabel = window.WHITE_LABEL_CONFIG;
    switch (whiteLabel?.name) {
      case WHITE_LABELS.MOTORCYCLE:
        return motoEngineDisplacementInCM3Options;
      case WHITE_LABELS.CAR:
      default:
        return carEngineDisplacementInCM3Options;
    }
  };

  return (
    <S.SidebarFilterWrapper>
      <EuiFormLabel>{formatMessage({ id: 'filters.engineDisplacementInCM3.label' })}</EuiFormLabel>
      <RangeFilter
        values={options as { min: string; max: string }}
        onChange={engineDisplacementInCM3}
        data={getOptions(getEngineDisplaceMentByDomain())}
      />
    </S.SidebarFilterWrapper>
  );
};
